import { Assembly } from '@/assembly/api/types';
import { AssemblyExpandedDetails } from '@/assembly/components/assembly-expanded-details';
import { Link } from '@/components/link';
import { LocationName } from '@/components/location-name';
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
} from '@/constants/hardfin-standard-icons';
import {
  Box,
  Button,
  Collapse,
  IconButton,
  Stack,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import { useState } from 'react';

interface Props {
  assembly: Assembly;

  handleRegisterAssembly: (assembly: Assembly) => void;
}

export function AssemblyTableRow({ assembly, handleRegisterAssembly }: Props) {
  const [open, setOpen] = useState(false);

  const buildDate = assembly.buildDate
    ? assembly.buildDate.toLocaleString({
        dateStyle: 'medium',
      })
    : null;

  const handleToggleExpand = () => {
    setOpen(!open);
  };

  return (
    <>
      <TableRow hover>
        <TableCell>
          <Stack direction="row" alignItems="center" spacing={1}>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={handleToggleExpand}
            >
              {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
            <Box>
              <Typography variant="subtitle2">{assembly.internalId}</Typography>
            </Box>
          </Stack>
        </TableCell>
        <TableCell>
          <Typography variant="body2">{assembly.item.name}</Typography>
        </TableCell>
        <TableCell>
          {assembly.location ? (
            <LocationName location={assembly.location} variant="body2" />
          ) : (
            <Typography variant="body2" color="text.secondary">
              Not set
            </Typography>
          )}
        </TableCell>
        <TableCell>
          {buildDate ? (
            <Typography variant="body2">{buildDate}</Typography>
          ) : (
            <Typography variant="body2" color="text.secondary">
              Not set
            </Typography>
          )}
        </TableCell>
        <TableCell>
          {assembly.asset ? (
            <Link
              to="/assets/$assetKey"
              params={{ assetKey: assembly.asset.key }}
            >
              View asset
            </Link>
          ) : (
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleRegisterAssembly(assembly)}
            >
              Register asset
            </Button>
          )}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 2 }}>
              <AssemblyExpandedDetails assembly={assembly} />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}
